<script>
  export let price, unit
</script>

<div class="row">
  <div class="col">
    <label for="price" class="form-label">Price</label>

    <div class="input-group">
      <div class="input-group-text">$</div>
      <input
        disabled
        type="number"
        class="form-control"
        id="price"
        placeholder="0.00"
        step="0.01"
        required
        value={price}
      />
    </div>
  </div>

  <div class="col">
    <label for="unit" class="form-label">Sell By</label>
    <!-- svelte-ignore a11y-no-onchange -->
    <select disabled id="unit" class="form-select" value={unit}>
      <option value="ea" selected>Each</option>
      <option value="lb">Pound</option>
    </select>
  </div>
</div>

<div class="row mt-1 mb-3">
  <div class="col">
    <em>The price and sell by unit for this item can not be changed.</em>
  </div>
</div>
